import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_WATER_PUMP',
  GET: 'GET_WATER_PUMP',
  CREATE: 'CREATE_WATER_PUMP',
  EDIT: 'EDIT_WATER_PUMP',
  DELETE: 'DELETE_WATER_PUMP',
  DUPLICATE: 'DUPLICATE_WATER_PUMP',
  CLEAR_ERROR: 'CLEAR_ERROR_WATER_PUMP',
};

export const clearErrorWaterPump = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchWaterPumpByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchWaterPump(pageSize, page, sorted, filtered, isPublic);
};

export const searchWaterPump = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_WATER_PUMP,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listWaterPump = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchWaterPump(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getWaterPump = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_WATER_PUMP}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createWaterPump = (name, type, powerRequired, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('type', type);
  formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `wp_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_WATER_PUMP,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editWaterPump = (id, name, type, powerRequired, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (type) formData.set('type', type);
  if (powerRequired) formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `wp_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_WATER_PUMP}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteWaterPump = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_WATER_PUMP}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateWaterPump = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_WATER_PUMP}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/ac_central/water_pump_actions.js